module.exports = __webpack_public_path__ + "static/media/logo-earned.7c6f13c2.svg";